
import { defineComponent } from 'vue';
import DefaultLayout from '@/ui/layouts/Default.vue';
import EmptyLayout from '@/ui/layouts/Empty.vue';
import Notification from "@/ui/components/bases/Notification.vue";
import ErrorModal from '@/ui/components/modals/ErrorModal.vue';
import { ui, dismissError, closeErrorModal, installNativeBridge } from './domain/ui';
import { requestAction } from './utils/cef';

export default defineComponent({
  name: 'App',
  components: {
    DefaultLayout,
    EmptyLayout,
    Notification,
    ErrorModal,
  },
  data() {
    return {
      ui,
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'default') + '-layout';
    },
  },
  mounted() {
    installNativeBridge();

    const w: any = window;
    w.showError = (message: string) => {
      try {
        const audio = new Audio('sounds/error.mp3');
        const played = audio.play();
        if (played && typeof played.catch === 'function') {
          played.catch(() => undefined);
        }
      } catch (e) {
        // Autoplay may be blocked, the notification is enough.
      }
      ui.error = message;
    };
  },
  methods: {
    dismissError,
    onPrimaryAction() {
      const action = ui.errorModal.primaryAction;
      closeErrorModal();
      if (action && action !== 'CLOSE') {
        requestAction(action, null);
      }
    },
    onSecondaryAction() {
      const action = ui.errorModal.secondaryAction;
      closeErrorModal();
      if (action && action !== 'CLOSE') {
        requestAction(action, null);
      }
    },
  },
});
